import { render, staticRenderFns } from "./DefaultOpeningHours.vue?vue&type=template&id=9450279a&scoped=true"
import script from "./DefaultOpeningHours.vue?vue&type=script&lang=js"
export * from "./DefaultOpeningHours.vue?vue&type=script&lang=js"
import style0 from "./DefaultOpeningHours.vue?vue&type=style&index=0&id=9450279a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9450279a",
  null
  
)

export default component.exports